import { cn } from '../../utils'

export function Loader({ className }: { className?: string }) {
	return (
		<svg
			className={cn('w-24 mx-auto', className)}
			version="1.1"
			id="L4"
			xmlns="http://www.w3.org/2000/svg"
			x="0px"
			y="0px"
			viewBox="0 0 100 100"
			enableBackground="new 0 0 0 0"
		>
			<circle fill="currentColor" stroke="none" cx="30" cy="50" r="6">
				<animate
					attributeName="opacity"
					dur="1s"
					values="0;1;0"
					repeatCount="indefinite"
					begin="0.1"
				></animate>
			</circle>
			<circle fill="currentColor" stroke="none" cx="50" cy="50" r="6">
				<animate
					attributeName="opacity"
					dur="1s"
					values="0;1;0"
					repeatCount="indefinite"
					begin="0.2"
				></animate>
			</circle>
			<circle fill="currentColor" stroke="none" cx="70" cy="50" r="6">
				<animate
					attributeName="opacity"
					dur="1s"
					values="0;1;0"
					repeatCount="indefinite"
					begin="0.3"
				></animate>
			</circle>
		</svg>
	)
}
